import React from "react";
import { Alert, Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isSuperAdmin } from "../../utils/roles";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function ModuleDisabledState({ projectId, title, description }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const superAdmin = isSuperAdmin(user);

  return (
    <Card elevation={0} sx={{ borderRadius: 4, border: "1px solid rgba(25,36,47,0.08)" }}>
      <CardContent sx={{ p: { xs: 3, md: 5 } }}>
        <Stack spacing={2.5} alignItems="flex-start">
          <Box sx={{ width: 58, height: 58, borderRadius: 3, display: "grid", placeItems: "center", bgcolor: "rgba(243,90,58,0.1)", color: BRAND.orange }}>
            <LockRoundedIcon />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 950, color: BRAND.dark }}>
              {title} no está habilitado
            </Typography>
            <Typography sx={{ color: "rgba(25,36,47,0.65)", mt: 1, maxWidth: 720 }}>
              {description}
            </Typography>
          </Box>
          <Alert severity="info" sx={{ width: "100%" }}>
            {superAdmin
              ? "Este módulo se controla desde la Configuración > Funcionalidades o desde el plan asignado al cliente."
              : "Esta función se activa al mejorar el plan del proyecto."}
          </Alert>
          <Button
            startIcon={superAdmin ? <SettingsRoundedIcon /> : <WorkspacePremiumRoundedIcon />}
            onClick={() =>
              navigate(
                superAdmin
                  ? `/dashboard/proyectos/${projectId}/configuracion/plan`
                  : `/dashboard/proyectos/${projectId}/configuracion/plan?feature=${encodeURIComponent(title)}`,
              )
            }
            variant="contained"
            sx={{ bgcolor: BRAND.orange, borderRadius: 999, textTransform: "none", fontWeight: 900 }}
          >
            {superAdmin ? "Ir a configuración" : "Mejorar plan"}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
